import generateRender from 'shared/utils/generateRender';
import DefaultFormContainer from './DefaultFormContainer';

const FormContainer = generateRender({
  default: DefaultFormContainer,
});

export default FormContainer;

